import { Collapse, theme, Typography } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import PositionFiles from "@/Pages/Overview/MyPortfolio/MyFiles/PositionFiles.jsx";
import TransactionFiles from "@/Pages/Overview/MyPortfolio/MyFiles/TransactionFiles.jsx";
import LinkList from "@/Pages/Overview/MyPortfolio/MyFiles/LinkList.jsx";

const MyFiles = () => {
  const { token } = theme.useToken();
  const panelStyle = {
    border: "none",
  };

  const getItems = (panelStyle) => [
    {
      key: "1",
      label: (
        <Typography.Text className="text-[16px] leading-[22px] font-medium">
          Transaction files
        </Typography.Text>
      ),
      children: <TransactionFiles />,
      style: panelStyle,
    },
    {
      key: "2",
      label: (
        <Typography.Text className="text-[16px] leading-[22px] font-medium">
          Position files
        </Typography.Text>
      ),
      children: <PositionFiles />,
      style: panelStyle,
    },
    {
      key: "3",
      label: (
        <Typography.Text className="text-[16px] leading-[22px] font-medium">
          Spreadsheet Links
        </Typography.Text>
      ),
      children: <LinkList />,
      style: panelStyle,
    },
  ];

  return (
    <>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        style={{
          background: token.colorBgContainer,
        }}
        items={getItems(panelStyle)}
      />
    </>
  );
};

export default MyFiles;
